const getPageNumber = (count, limit) => {
  return Math.ceil(count / limit);
};

export default getPageNumber;
